module.exports = __webpack_public_path__ + "img/search-icon.3238dec3.svg";